import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import { PopoverOrigin } from "@mui/material/Popover/Popover";
import Typography from "@mui/material/Typography";
import clsx from "clsx";
import { FC, MouseEvent, ReactNode, useState } from "react";
import { COLOR_ERROR, COLOR_BLACK, COLOR_GREY_8 } from "../../theme/colors";
import { MoreIcon } from "../../theme/icons/MoreIcon";
import { StyledMenu } from "./styled";

export type DropdownListItemProps = {
  title: string;
  style?: "remove" | "normal";
  onClick: () => void;
  component?: ReactNode;
};

type DropdownListProps = {
  icon?: ReactNode;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
  items: DropdownListItemProps[];
  className?: string;
};

const DropdownList: FC<DropdownListProps> = (props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event: MouseEvent) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls="long-menu"
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        {props.icon || <MoreIcon color={COLOR_GREY_8} />}
      </IconButton>
      <StyledMenu
        className={props.className}
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        anchorOrigin={
          props.anchorOrigin ?? {
            vertical: "top",
            horizontal: "right",
          }
        }
        transformOrigin={
          props.transformOrigin ?? {
            vertical: "top",
            horizontal: "right",
          }
        }
        open={open}
        onClose={handleClose}
      >
        {props.items.map(({ title, style, onClick, component }) => {
          return (
            <Box key={title}>
              <MenuItem
                className={clsx(style)}
                onClick={(event) => {
                  onClick();
                  handleClose(event);
                }}
              >
                {component || (
                  <Typography
                    variant="bodyMRegular"
                    color={style === "remove" ? COLOR_ERROR : COLOR_BLACK}
                  >
                    {title}
                  </Typography>
                )}
              </MenuItem>
            </Box>
          );
        })}
      </StyledMenu>
    </>
  );
};

export default DropdownList;
